import { createContext, useContext } from "react";

const SelectedEventStateContext = createContext();
const SelectedEventStateProvider = SelectedEventStateContext.Provider;
const useSelectedEventStateContext = () => useContext(SelectedEventStateContext);

export { SelectedEventStateContext, SelectedEventStateProvider, useSelectedEventStateContext };
